import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import {getColor, getRem, ms} from '../../../../styles';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

export const Container = styled(View)<StyledProps>`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${ms(12)} ${ms(16)};
  border-radius: ${ms(12)};
  border: ${ms(1)} solid ${getColor('border1')};

  ${p =>
    p.isSelected &&
    css`
      border-color: ${getColor('border6')};
    `}
`;

export const CardContainer = styled(View)`
  flex-direction: row;
  align-items: center;
`;

export const Number = styled(Text).attrs({weight: 'semibold'})`
  font-size: ${getRem(16)};
  line-height: ${getRem(20)};
  letter-spacing: ${getRem(-0.24)};
  margin-left: ${ms(16)};
`;
